/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the desktop downloads and select the build for your operating system and processor.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看桌面下载，选择与操作系统和处理器匹配的构建。`)
};

/**
* | output |
* | --- |
* | "Review the desktop downloads and select the build for your operating system and processor." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_Table_Rows_1_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_table_rows_1_1 as "gc.search_guides.what_is_gridcraft.sections.3.table.rows.1.1" }